import { Avatar, Box, Button, Chip, Dialog, DialogActions, DialogContent, Divider, Typography, CardMedia, DialogTitle } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import BadgeIcon from '@mui/icons-material/Badge';
import StoreIcon from '@mui/icons-material/Store';
import CampaignIcon from '@mui/icons-material/Campaign';
import PropTypes from 'prop-types';
import React from 'react';
import { getUser } from 'src/utils/Common';
import { styled } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'src/utils/axios';
import Confetti from 'react-confetti';

const styles = {
  root: {

  },
  greetingCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    p: 3,
    mb: 3,
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    border: '1px solid rgba(0,0,0,0.06)'
  },
  greetingAvatar: {
    width: 64,
    height: 64,
    fontSize: '1.5rem',
    fontWeight: 700,
    bgcolor: 'rgba(255,152,0,0.12)',
    color: '#FF9800'
  },
  icon: {
    align: 'center',
    textAlign: 'center'
  },
};

const getInitials = (name) => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const StyledCardMedia = styled(CardMedia)({
  height: '100%',
  width: '100%',
  backgroundSize: 'contain',
});

function Timeline({ className, ...rest }) {
  const SessionUser = getUser();
  const visibleMessages = (SessionUser.Message?.split(String.fromCharCode(10)) || [])
    .map((m) => m?.trim())
    .filter(Boolean);
  const [openPerakendeTV, setopenPerakendeTV] = React.useState(false);
  const [avatarEmployee, setAvatarEmployee] = React.useState(null);

  const [openBirthday, setopenBirthday] = React.useState(false);

  const [openBirthDayMessage, setOpenBirthDayMessage] = React.useState(false);
  const [birthDayMessage, setBirthDayMessage] = React.useState('');

  const [openWorkAnniversary, setopenWorkAnniversary] = React.useState(false);
  const [workAnniversaryMessage, setWorkAnniversaryMessage] = React.useState('');

  const [celebrationType, setCelebrationType] = React.useState(0);
  const [celebrationMessage, setCelebrationMessage] = React.useState('');
  const [openCelebrationMessage, setOpenCelebrationMessage] = React.useState(false);

  const handleCloseBirthday = () => {
    setopenBirthday(false);
    SetApolloEmployeeNotification(1);
  };


  React.useEffect(() => {

    if (parseInt(SessionUser.HappyBirthday) === 1) {
      setTimeout(() => {
        // setopenBirthday(true);
      }, 2000);
    }

    //Bayiler için özel doğum günü mesajı
    if (parseInt(SessionUser.BirthDayNotification) === 1 && SessionUser.BirthDayNotificationMessage) {
      const message = SessionUser.BirthDayNotificationMessage.replace("@CalisanAdSoyad", SessionUser.NameSurname);
      setBirthDayMessage(message);
      setOpenBirthDayMessage(true);
    }

    //Bayiler için özel yıl dönümü mesajı
    if (parseInt(SessionUser.WorkAnniversaryNotification) === 2 && SessionUser.WorkAnniversaryNotificationMessage) {
      const message = SessionUser.WorkAnniversaryNotificationMessage.replace("@CalisanAdSoyad", SessionUser.NameSurname);
      setWorkAnniversaryMessage(message);
      setopenWorkAnniversary(true);
    }

    //BAyiler için özel kutlama mesajı
    if (parseInt(SessionUser.CelebrationNotification) > 2 && SessionUser.CelebrationNotificationMessage) {
      const message = SessionUser.CelebrationNotificationMessage.replace("@CalisanAdSoyad", SessionUser.NameSurname);
      setCelebrationMessage(message);
      setCelebrationType(parseInt(SessionUser.CelebrationNotification));
      setOpenCelebrationMessage(true);
    }


    axios.get('/GetBanner')
      .then((response) => {
        const res = response.data;
        if (res.length === 0) {
          setopenPerakendeTV(false);
        } else {
          setAvatarEmployee(res[0].Resim);
          setopenPerakendeTV(true);
        }
      }).catch(error => {
        setopenPerakendeTV(false);
      });
  }, []);

  const SetApolloEmployeeNotification = (type) => {
    axios.get('/SetApolloEmployeeNotification/' + type)
  }

  const handleCloseCelebrationNotification = (type) => {
    if (type === 1) {
      setOpenBirthDayMessage(false);
    }
    else if (type === 2) {
      setopenWorkAnniversary(false);
    }
    else {
      setOpenCelebrationMessage(false);
    }
    SetApolloEmployeeNotification(type);
  }

  const getDialogWidth = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      return element.clientWidth;
    }
  }

  const getDialogHeight = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      return element.clientHeight;
    }
  }




  const PerakendeTVOpen = (event) => {
    event.persist();
    window.open("https://www.perakendetv.net/detail/F63131EE-B0F8-456A-8A90-FEF4D09ED9FF");
    event.persist();
  }

  return (
    <div
      {...rest}
      className={className}
      style={styles.root}
    >
      <Box sx={styles.greetingCard}>
        <Avatar sx={styles.greetingAvatar}>{getInitials(SessionUser.NameSurname)}</Avatar>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Merhaba, {SessionUser.NameSurname || 'Kullanıcı'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
            {SessionUser.Role && (
              <Chip
                size="small"
                icon={<BadgeIcon sx={{ color: '#FF9800 !important' }} />}
                label={SessionUser.Role}
                sx={{ bgcolor: 'rgba(255,152,0,0.1)', color: 'text.primary', fontWeight: 600 }}
              />
            )}
            {SessionUser.TopServiceShopName && (
              <Chip
                size="small"
                icon={<BusinessIcon sx={{ color: '#FF9800 !important' }} />}
                label={SessionUser.TopServiceShopName}
                sx={{ bgcolor: 'rgba(255,152,0,0.1)', color: 'text.primary', fontWeight: 600 }}
              />
            )}
            {(SessionUser.ServiceShopCode || SessionUser.ServiceShopName) && (
              <Chip
                size="small"
                icon={<StoreIcon sx={{ color: '#FF9800 !important' }} />}
                label={[SessionUser.ServiceShopCode, SessionUser.ServiceShopName].filter(Boolean).join(' - ')}
                sx={{ bgcolor: 'rgba(255,152,0,0.1)', color: 'text.primary', fontWeight: 600 }}
              />
            )}
          </Box>
          {visibleMessages.length > 0 && (
            <Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
              {visibleMessages.map((m, index) => (
                <Box key={index} sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75 }}>
                  <CampaignIcon fontSize="small" sx={{ color: '#FF9800', mt: '2px' }} />
                  <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.6 }}
                  >
                    {m}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
      <Dialog
        open={openBirthday}
        onClose={handleCloseBirthday}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Typography variant="h6" component="h4">
            <br />
            Sevgili {SessionUser.NameSurname},
            <br />
            <br />
            Doğum gününü kutlar sevdiklerinle birlikte sağlık, mutluluk ve başarılarla dolu
            nice seneler dilerim.
            <br />
            <br />
            İyi ki doğdun!
            <br />
            <br />
            Sevgilerimle,
            <br />
            Hüseyin Şerif Beyaztaş
            <br />
            Arçelik Müşteri Hizmetleri Direktörü
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBirthday} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPerakendeTV}
        fullWidth
        maxWidth="lg"
        onClose={() => setopenPerakendeTV(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">Bilgilendirme</DialogTitle>
        <Divider />
        <DialogContent onClick={PerakendeTVOpen}>
          <StyledCardMedia
            component="img"
            alt="Banner"
            src={avatarEmployee}
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            onClick={() => setopenPerakendeTV(false)}
            variant="contained"
            color="secondary"
            endIcon={<CloseIcon>Close</CloseIcon>}>
            Kapat
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openBirthDayMessage}
        onClose={() => handleCloseCelebrationNotification(1)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent id='birthDayDialog'>
          <Confetti
            width={getDialogWidth('birthDayDialog')}
            height={getDialogHeight('birthDayDialog')}
          />
          <div dangerouslySetInnerHTML={{ __html: birthDayMessage }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseCelebrationNotification(1)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openWorkAnniversary}
        onClose={() => handleCloseCelebrationNotification(2)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent id='workAnniversaryDialog'>
          <Confetti
            width={getDialogWidth('workAnniversaryDialog')}
            height={getDialogHeight('workAnniversaryDialog')}
          />
          <div dangerouslySetInnerHTML={{ __html: workAnniversaryMessage }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseCelebrationNotification(2)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCelebrationMessage}
        onClose={() => handleCloseCelebrationNotification(celebrationType)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
      >
        <DialogContent id='celebrationDialog'>
          <Confetti
            width={getDialogWidth('celebrationDialog')}
            height={getDialogHeight('celebrationDialog')}
          />
          <div dangerouslySetInnerHTML={{ __html: celebrationMessage }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseCelebrationNotification(celebrationType)} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>



    </div>
  );
}

Timeline.propTypes = {
  className: PropTypes.string
};

export default Timeline;
